import { useInstance } from '@bridgemoney/core';
import { SystemService } from '../../../services';
import { SystemStore, useSystemStore } from '../../SystemStore';
import { LighthouseEnum, LighthouseEnums } from '../../../types';

export interface UseEnums {
   fetchEnums(names?: LighthouseEnum[]): Promise<void>;
   fetchAllEnums(): Promise<void>;
   enums: LighthouseEnums;
}

export function useEnums(): UseEnums {
   const service = useInstance<SystemService>('SystemService');

   const enums = useSystemStore((state: SystemStore) => state.enums);
   const setEnums = useSystemStore((state: SystemStore) => state.setEnums);

   async function fetchEnums(names: LighthouseEnum[] = []): Promise<void> {
      const enumsToRequest: LighthouseEnum[] = [];

      names.forEach((name) => {
         if (!enums[name] || enums[name].length === 0) {
            enumsToRequest.push(name);
         }
      });

      if (enumsToRequest.length > 0) {
         const res = await service.fetchEnums(enumsToRequest);

         if (!res.error && res.data) {
            const newEnums = Object.assign({}, enums, res.data);
            setEnums(newEnums);
         }
      }
   }

   async function fetchAllEnums(): Promise<void> {
      const names = Object.keys(LighthouseEnum);
      const res = await service.fetchEnums(names as LighthouseEnum[]);

      if (!res.error && res.data) {
         const newEnums = Object.assign({}, enums, res.data);
         setEnums(newEnums);
      }
   }

   return {
      fetchEnums,
      fetchAllEnums,
      enums,
   };
}
